import { servicesQueryOptions } from '../services/services-api'
import { ServicesTab } from '../services/services-tab'
import type { FetchQueryOptions } from '@tanstack/react-query'
import { CustomerInfoTab } from '../customer/customer-info-tab'
import { financingQueryOptions } from '../invoicing/api'
import { PaymentTab } from '../invoicing/payment-tab'
import { ShippingTab } from '../shipping/shipping-tab'
import { reviewQueryOptions } from '../review/review-api'
import { ReviewTab } from '../review/review-tab'
import { EquipmentStage } from '../equipment/equipment-stage'
import { TaxesTab } from '../tax/taxes-tab'
import { taxesQueryOptions } from '../tax/taxes-api'
import type { WorkflowTabRegistration } from './types'
import { StartTab } from '../project/start-tab'

// One line per stage, in workflow order. A stage owner replaces only its own line's component
// (and adds `warm` when the stage has a read to preload). Never reorder or reformat.
export const workflowTabs: readonly WorkflowTabRegistration[] = [
  { key: 'customer', label: 'Customer', component: CustomerInfoTab },
  { key: 'equipment', label: 'Equipment', component: EquipmentStage },
  { key: 'shipping', label: 'Shipping', component: ShippingTab },
  { key: 'services', label: 'Services', component: ServicesTab, warm: (api, quoteId) => servicesQueryOptions(api, quoteId) as FetchQueryOptions },
  { key: 'tax', label: 'Tax', component: TaxesTab, warm: (api, quoteId) => taxesQueryOptions(api, quoteId) as FetchQueryOptions },
  { key: 'financing', label: 'Payment', component: PaymentTab, warm: (api, quoteId) => financingQueryOptions(api, quoteId) as FetchQueryOptions },
  { key: 'approval', label: 'Review', component: ReviewTab, warm: (api, quoteId) => reviewQueryOptions(api, quoteId) as FetchQueryOptions },
  { key: 'invoicing', label: 'Start', component: StartTab },
]

export const workflowTabsByKey = new Map(workflowTabs.map((tab) => [tab.key, tab]))
